import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { IRpaConnectBluePrismState } from 'app/rpa-bots/core/IRpaBots';

const bluePrismSelector = (state: IAppState) => state.rpaState.bluePrismConnectors;

export const getBluePrismConnList = createSelector(
    bluePrismSelector,
    (state: IRpaConnectBluePrismState) => state.connectors
);

export const getIsLoadingList = createSelector(
    bluePrismSelector,
    (state: IRpaConnectBluePrismState) => state.isLoadingList
);

export const getIsLoadingDetail = createSelector(
    bluePrismSelector,
    (state: IRpaConnectBluePrismState) => state.isLoadingDetail
);

export const getBluePrismCurrentConnector = createSelector(
    bluePrismSelector,
    (state: IRpaConnectBluePrismState) => state.currentConnector
);
